import { render, staticRenderFns } from "./confetti-animation.vue?vue&type=template&id=6775befe&"
import script from "./confetti-animation.vue?vue&type=script&lang=js&"
export * from "./confetti-animation.vue?vue&type=script&lang=js&"
import style0 from "./confetti-animation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports